/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {SurveyFormInputText} from "../SurveyFormInputText";
import {SurveyFormInputFile} from "../SurveyFormInputFile";
import {SurveyFormComposedInput} from "../SurveyFormComposedInput";

export const SurveyFormFileWithTextInput = (props) => 
    <SurveyFormComposedInput Validation={props.Validation}>
        <SurveyFormInputFile {...props} Validation={null}/>
        <SurveyFormInputText {...props} Validation={null}/>
    </SurveyFormComposedInput>;
